





















































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import ButtonFollow from '@/components/ButtonFollow.vue'
import VSeeMoreWrapper from '@/components/VSeeMoreWrapper.vue'

const profileDescriptionMarkdown = require('markdown-it')({
  html: false,
  breaks: true, // Convert '\n' in paragraphs into <br>
  linkify: true,        // Autoconvert URL-like text to links
})

@Component({
  components: { VSeeMoreWrapper, ButtonFollow },
  apollo: {
    user: {
      variables() {
        return {
          uid: this.uid,
        }
      },
      query() {
        return this.$gql(`
          query GET_USER($uid: String!) {
            user(uid: $uid) {
              uid
              name
              email
              commentTokensThreshold
              profileDescription
              profileImageUrl
              isFollowed
              isIgnored
              followersCount
              followingCount
              commentsCount
              createdAt
            }
          }`)
      },
    },
  },
})
export default class UserPage extends Vue {
  @Prop() uid!: string
  user: any
  menuOrDialog1: boolean = false

  mounted() {
    this.$apollo.queries.user.refetch()
  }

  @Watch('user')
  onUserChanged(user) {
    if (user) {
      document.title = user.name + ' - ' + this.$appName
    }
  }


  loading: boolean = true
  comments: any[] = []
  order: string = '' // @todo

  get profileDescription() {
    if (this.user && this.user.profileDescription) {
      return (<any>profileDescriptionMarkdown).render(this.user.profileDescription)
    }
  }

  ignore() {
    if (!window.confirm('Ignoring this person will prevent their comments from appearing in discussions.')) return
    this.$apollo.mutate({
      mutation: this.$gql(
        `mutation IGNORE_USER ($userUid: String!) {
          ignoreUser(userUid: $userUid) {
            uid
          }
        }`),
      variables: {
        userUid: this.user.uid,
      },
    })
      .then(data => {
        this.user.isIgnored = true
      })
      .catch((error) => {
        let { graphQLErrors } = error
        if (graphQLErrors[0].extensions.category === 'custom') {
          this.$eventBus.$emit('snackbar', { text: graphQLErrors[0].message })
        }
      })

  }

  unignore() {
    this.$apollo.mutate({
      mutation: this.$gql(
        `mutation UNIGNORE_USER ($userUid: String!) {
          unignoreUser(userUid: $userUid) {
            uid
          }
        }`),
      variables: {
        userUid: this.user.uid,
      },
    })
      .then(data => {
        this.user.isIgnored = false
      })
      .catch((error) => console.error(error))
  }

  formatTime(time) {
    const ONE_MONTH = 30 * 24 * 60 * 60 * 1000
    let date = new Date(time)
    let monthName = date.toLocaleString('default', { month: 'long' })
    let year = date.getFullYear()
    return `${monthName} ${year}`
  }

}

